<script>


import StatusAwareAtom from "../StatusAwareComponent.vue";

export default {
  name: "ClockStatusIndicator",
  extends: StatusAwareAtom,
  computed: {
    isWorking() {
      return this.status === this.statuses.working;
    },
    isCompleted() {
      return this.status === this.statuses.completed;
    }
  }
}
</script>

<template>
  <div>
    <div v-if="isWorking"
         class="flex items-center justify-center w-12 h-12 bg-green-500 me-o me-lg-2 rounded-full">
      <div class="pulse d-flex">
        <i class="fi fi-sr-stop text-danger d-flex icon-indicator active"></i>
      </div>
    </div>
    <div v-else>
      <i class="fi fi-sr-play text-success d-flex icon-indicator"></i>
    </div>
  </div>
</template>

<style scoped>
.icon-indicator {
  font-size: 22px;
}

.icon-indicator.active {
  font-size: 12px;
}

.pulse {
  border-radius: 10%;
  box-shadow: 0px 0px 1px 1px #FF67671A;
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px #FF67673A;
  }
  100% {
    box-shadow: 0 0 0 15px #FF67670A;
  }
}

</style>
